export class File {
    extension: string;
    filename: string;
    fileId: number;
    mime: string;
    type: string;
    url: string;
    folderId: number;
        folderName: string;
    constructor(data) {
        this.extension = data.extension;
        this.filename = data.filename;
        this.fileId = data.fileId;
        this.mime = data.mime;
        this.type = data.type;
        this.url = data.url;
        this.folderId = data.folderId;
        this.folderName = data.folderName;
     }

    
}


// WEBPACK FOOTER //
// ./src/app/components/class/expense/file.ts